export enum CustomerUserStatusEnum {
  REQUESTED = 'REQUESTED',
  INEXISTENT = 'INEXISTENT',
  POOL_REMOVED = 'POOL_REMOVED',
  EXISTENT = 'EXISTENT',
}
